export const formatBankAccountDisplay = (account) => {
  if (!account) return '';

  const displayName = account.display_name || '';
  const bankName = account.bank_name || '';
  const lastFour = account.account_last_four || '';
  const businessPayeeName = account.business_payee_name || '';

  return `${displayName} - ${bankName} - (***${lastFour}) - ${businessPayeeName}`;
};
